<template>
    <div id="app">
        <AppLayout />
    </div>
</template>
<script>
    import AppLayout from './components/Layout.vue';
    export default {
        name: 'App',
        components: { AppLayout }
    }
</script>
<style>
    /*iG˦ */
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        color: #2c3e50;
        margin-top: 0;
    }
</style>